import React from 'react';

import { SingleSelect } from '@sine/sine-ui-components';

import { type PlanSelectOption } from '../../../services/billing/billing.types';

interface PlanSelectorProps {
  'options': Array<PlanSelectOption>;
  'value'?: PlanSelectOption;
  'onChange': (value: PlanSelectOption | undefined) => void;
  'disabled'?: boolean;
  'data-st-ext'?: string;
}

export default function PlanSelector({
  options,
  value,
  onChange,
  disabled,
  'data-st-ext': dataStExt,
}: PlanSelectorProps) {
  return (
    <SingleSelect
      options={options}
      value={value}
      onChange={(selectedValue) => onChange(selectedValue as PlanSelectOption)}
      noSpaceReservation
      disabled={disabled}
      data-st-ext={dataStExt || 'select-plans'}
      disableAutosort
    />
  );
}
